import { useTranslation } from '@/i18n/client';
import { Pagination, TextField } from '@mui/material';
import { observer } from 'mobx-react';
import { useState } from 'react';
import styles from './index.module.scss';

interface paginationProps {
  currentPage: number;
  totalPages: number;
  handlePageChange?: (num: number) => void;
}

const pagination: React.FC<paginationProps> = observer(
  ({ currentPage, totalPages, handlePageChange }) => {
    const { t } = useTranslation();
    const [inputPage, setInputPage] = useState('');

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
      setInputPage(''); // 清空输入框
      handlePageChange && handlePageChange(value);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputPage(event.target.value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        const pageNumber = Number(inputPage);
        if (pageNumber < 1) {
          // 跳转到第一页
          handlePageChange && handlePageChange(1); // 通知父组件
        } else if (pageNumber > totalPages) {
          // 跳转到最后一页
          handlePageChange && handlePageChange(totalPages); // 通知父组件
        } else {
          // 跳转到指定页
          handlePageChange && handlePageChange(pageNumber); // 通知父组件
        }
        setInputPage(''); // 清空输入框
      }
    };
    return (
      <div className={styles.wrap}>
        <Pagination
          color='primary'
          count={totalPages} // 总页数
          page={currentPage} // 当前页
          onChange={handleChange} // 页码变化时的回调
          variant='outlined' // 样式选项
          shape='rounded' // 页码形状
        />
        <span className={styles.tip_text}>{t('order.orderList.pagination.goToPage')}</span>
        <TextField
          type='number'
          value={inputPage}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown} // 添加回车事件处理
          sx={{
            width: '40px',
            '& input': {
              height: '32px', // 设置输入框的高度
              padding: '0 8px', // 自定义内边距
              fontSize: '14px',
            },
            '& input::-webkit-outer-spin-button': {
              display: 'none',
            },
            '& input::-webkit-inner-spin-button': {
              display: 'none',
            },
          }}
        />
      </div>
    );
  },
);

export default pagination;
